import { every, get } from 'lodash'

import areSameValue from './are-same-value'

const areEqualByProps = (sourceObject, targetObject, propsToCompare) =>
  every(propsToCompare, propToCompare =>
    areSameValue(
      get(sourceObject, propToCompare),
      get(targetObject, propToCompare),
    ),
  )

export default areEqualByProps
